import axiosConfig from "./axiosConfig";

export interface LandlordResearchResponse {
  status: "pending";
  operationKey: string;
  siteId: string;
  // True when an identical research run was already in flight for this row
  // and we coalesced onto it rather than spawning a second paid run.
  deduped?: boolean;
}

// Kick off the agentic landlord-research run for one VOA row as a
// long-running operation. Returns {operationKey, siteId} immediately; the
// worker web-searches for the building's owner and writes cited candidates
// onto the row. The FE polls useOperation(operationKey, siteId) until
// terminal, then refetches the row to show the candidates.
const postVoaResearchLandlord = async (
  authToken: string,
  sourceRef: string
): Promise<LandlordResearchResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/voa-research-landlord`,
    { sourceRef },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postVoaResearchLandlord;
